import Tooltip from './ant';

export default Tooltip;
